import clsx from 'clsx';

import { useClasses } from 'entities/classes';

import styles from './styles.module.scss';

type ClassesSectionProps = {
  selectedClassesBks: string[];
};

export const ClassesSection = ({ selectedClassesBks }: ClassesSectionProps) => {
  const { isFetching, classes } = useClasses();

  const selectedClasses = classes?.filter((classObj) =>
    selectedClassesBks.includes(classObj.classKey),
  );

  if (isFetching) return <div>Loading classes...</div>;

  return (
    <div className={styles.classesOptionsWrapper}>
      {selectedClasses?.map((selectedClass) => (
        <div
          key={selectedClass.classKey}
          className={clsx(
            'amplify-checkbox',
            'checkbox-blue',
            'rhythm-checkbox',
            styles.classCheckbox,
          )}
        >
          <label className={clsx(styles.optionWrapper, styles.disabled)}>
            <input
              disabled
              type="checkbox"
              value={selectedClass.displayName}
              checked
            />
            <div className={clsx('faux-input', styles.checkboxIcon)} />
            <span
              className={styles.classTitle}
              data-testid="assigned-class-title"
            >
              {selectedClass.displayName}
            </span>
          </label>
        </div>
      ))}
    </div>
  );
};
